import {
  CREATE_NEW_GET_ZIP_TIER,
  DELETE_ZIP_TIER,
  DELETE_ZIP_TIER_ERROR,
  DELETE_ZIP_TIER_SUCCESS,
  GET_ZIP_TIERS,
  GET_ZIP_TIERS_ERROR,
  GET_ZIP_TIERS_SUCCESS,
  MODIFY_ZIP_TIER,
  MODIFY_ZIP_TIER_ERROR,
  MODIFY_ZIP_TIER_SUCCESS,
  NEW_ZIP_TIER_ERROR,
  NEW_ZIP_TIER_SUCCESS,
} from "./actionTypes"

export const getZipTiers = () => ({
  type: GET_ZIP_TIERS,
});

export const getZipTiersSuccess = (zipTiers) => ({
  type: GET_ZIP_TIERS_SUCCESS,
  payload: zipTiers,
});

export const getZipTiersError = (error) => ({
  type: GET_ZIP_TIERS_ERROR,
  payload: error,
});

export const createNewZipTier = (zipTier) => ({
  type: CREATE_NEW_GET_ZIP_TIER,
  payload: zipTier,
});

export const createNewZipTierSuccess = (zipTier) => ({
  type: NEW_ZIP_TIER_SUCCESS,
  payload: zipTier,
});

export const createNewZipTierError = (error) => ({
  type: NEW_ZIP_TIER_ERROR,
  payload: error,
});

export const modifyZipTiers = (zipTier) => ({
  type: MODIFY_ZIP_TIER,
  payload: zipTier,
});

export const modifyZipTiersSuccess = (zipTier) => ({
  type: MODIFY_ZIP_TIER_SUCCESS,
  payload: zipTier,
});

export const modifyZipTiersError = (error) => ({
  type: MODIFY_ZIP_TIER_ERROR,
  payload: error,
});

export const deleteZipTier = (zipTier) => ({
  type: DELETE_ZIP_TIER,
  payload: zipTier,
});

export const deleteZipTierSuccess = (zipTier) => ({
  type: DELETE_ZIP_TIER_SUCCESS,
  payload: zipTier,
});

export const deleteZipTierError = (error) => ({
  type: DELETE_ZIP_TIER_ERROR,
  payload: error,
});
